<template>
  <div id="app">
    <!-- 头部组件 -->
    <div class="header">
      <div class="headerbox">
        <div>
          <img class="topImg" src="@/assets/imgs/toplogo-sign.png" alt />
        </div>
        <div class="rightBox">
          <el-dropdown trigger="click" @command="handleOpenDialog">
            <img
              class="userImg"
              v-if="avatar"
              :src="avatar"
              :onerror="defaultAvatarImgae"
              alt
            />
            <img class="userImg" v-else src="../../assets/imgs/hello.png" alt />
            <span class="el-dropdown-link tophelp">
              {{ nickname }}
            </span>
            <el-dropdown-menu slot="dropdown" class="downlist">
              <el-dropdown-item command="0">联系客服</el-dropdown-item>
              <el-dropdown-item>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <section style="min-height:90vh;" v-html="datas.intro"></section>
    <!-- 联系客服弹窗 -->
    <div class="onebox">
      <el-dialog
        title="联系客服"
        :visible.sync="isShowContact"
        width="22%"
        center
        style="border-radius: 8px"
        class="showBox"
      >
        <div class="contactBox">
          <div class="leftimg">
            <img src="@/assets/imgs/hello.png" alt />
          </div>
          <div class="rightText">
            <p>客服电话 : 13524808972</p>
            <p>如您在使用过程中遇到任何问题，请联系我们的工作人员。</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer contactFooter">
          <el-button type="primary" @click="isShowContact = false"
            >知道了</el-button
          >
        </span>
      </el-dialog>
    </div>
    <div class="footer">
      <p>
        Copyright 2007-{{ currentYear }}©LaoYaoBa.com™Inc.All rights reserved |
        闽ICP备17032949号-2
      </p>
      <p>闽公网安备 35020502000344号</p>
    </div>
  </div>
</template>
<script>
import PublicApi from "@/api/PublicModule";
import { removeToken, removeTime } from "@/utils/auth";
export default {
  data() {
    return {
      defaultAvatarImgae:
        'this.src="' + require("../../assets/imgs/hello.png") + '"',
      avatar: "",
      // 联系客服弹窗是否显示
      isShowContact: false,
      nickname: "",
      currentYear: "",
      datas:{}
    };
  },
  methods: {

    handleOpenDialog(e) {
      if (e === "0") {
        this.isShowContact = true;
      } else if (e === "1") {
        this.isShowContact = false;
      } else {
        removeToken();
        removeTime();
        localStorage.setItem("isLogin", "2");
        localStorage.removeItem("account");
        this.$router.push({
          path: "/login",
        });
      }
    },
    account() {
      var that = this;
      var account = JSON.parse(localStorage.getItem("account")) || {};
      that.nickname = account.nickname;
      that.avatar = account.avatar;
    },
    getAdvertDetails(){
      let params={
        slid_id:this.$route.query.slid_id
      }
      PublicApi.getAdvertDetails(params)
        .then(res => {
          this.datas = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {this.getAdvertDetails()},
  created() {
    this.account();
    let date = new Date();
    this.currentYear = date.getFullYear();
  },
};
</script>
<style scoped>

.header {
  width: 100%;
  min-width: 1280px;
  height: 50px;
  background: #003068;
}
.headerbox {
  width: 1280px;
  height: 100%;
  min-width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
}
.headerbox .topImg {
  width: 94px;
  height: 22px;
  margin-top: 14px;
}
.headerbox .topusername {
  line-height: 50px;
  font-size: 12px;
  color: #666666;
  cursor: pointer;
}
.headerbox .userImg {
  display: inline-block;
  width: 24px;
  height: 24px;
  vertical-align: middle;
  border-radius: 50%;
}
.header .tophelp {
  line-height: 50px;
  font-size: 12px;
  color: #fff;
}

.footer {
  width: 100%;
  height: 150px;
  bottom: -100px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  padding: 19px 0 0 0;
  box-sizing: border-box;
}
.footer p {
  font-size: 12px;
  color: #333;
  line-height: 16px;
}
</style>
<style>
.onebox .el-dialog--center {
  min-width: 453px;
}
.el-dropdown-menu__item {
  font-size: 12px;
}
.showBox .el-dialog__body {
  padding-bottom: 0 !important;
}
.el-dialog__footer {
  padding-bottom: 30px;
  padding-top: 40px;
}
.contactFooter .el-button {
  width: 116px;
  height: 35px;
  border-radius: 4px;
  line-height: 0;
}
.Feedbackfooter .el-button {
  width: 90px;
  height: 35px;
  border-radius: 4px;
  line-height: 0;
}
.el-dialog__header {
  border-bottom: 1px solid #f5f6f9;
  padding: 15px 0 12px;
}
.el-icon--right {
  margin-left: 0 !important;
  transition: transform 0.3s, -webkit-transform 0.3s;
}

</style>




// WEBPACK FOOTER //
// src/views/advert/index.vue